/*
 * @Author: yanyongchao
 * @Date: 2018-12-30 23:42:56
 */
import { Toast } from 'fs-ui'
/**
 * 拼接对象为请求字符串
 * @param {Object} obj - 待拼接的对象
 * @returns {string} - 拼接成的请求字符串
 */
export function encodeSearchParams (obj) {
  const params = []
  Object.keys(obj).forEach(key => {
    let value = obj[key]
    // 如果值为undefined我们将其置空
    if (typeof value === 'undefined') {
      value = ''
    }
    // 对于需要编码的文本（比如说中文）我们要进行编码
    params.push([key, encodeURIComponent(value)].join('='))
  })
  return params.join('&')
}

/**
 * toast提示
 * @param {object} param 传入的配置项
 */
export const $toast = ({ message, type = 'text', time = 2000 } = {}) => {
  return new Promise(resolve => {
    // eslint-disable-next-line
    const temp = new Toast({
      type,
      message,
      duration: 0
    })
    setTimeout(() => {
      temp.value = false
      resolve()
    }, time)
  })
}

/**
 * loading提示
 * @param {object} param 传入的配置项
 */
export const $loading = ({ message = '信息提交中...', type = 'loading', overlay = false } = {}) => {
  return new Toast({
    message,
    type,
    duration: 0,
    overlay,
    value: false
  })
}
